import createPrivateAdminPanelInstance from "../api/PrivateAdminPanelInstance";

// Every staff-side query hook builds an authenticated axios instance the
// same way: pull the staff token out of localStorage, parse it, hand the
// AccessToken to `createPrivateAdminPanelInstance`. Centralising the read
// here keeps that knowledge in one place — when the token storage shape
// changes (see the `getStoredAccessToken()` follow-up tracked in
// docs/planning/affiliates-todos.md), there's exactly one site to update.
// Lives at the `queries/` root rather than under `queries/affiliates/`
// because every domain hook will end up calling it.

type StoredToken = { AccessToken?: string };

/**
 * Build a private (staff-token authenticated) axios instance for the
 * admin-panel API. When `dashboardBaseUrl` is true, routes against the
 * alternate dashboard/game-pass-admin backend. Returns an unauthenticated
 * instance when no token is in localStorage so callers don't have to
 * special-case the logged-out path — the request will just fail at the API
 * gateway with a 401.
 */
export const getPrivateInstance = (dashboardBaseUrl = false) => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  return createPrivateAdminPanelInstance(token?.AccessToken, dashboardBaseUrl);
};